import React from "react";
import { Box, Typography } from "@mui/material";
import logo from "../../images/short_logo.png";
import profileData from "../../profileData.js";
import IconButton from "@mui/material/IconButton";
import { motion } from "framer-motion";
import "./ContactMe.css";

const ContactMe = () => {
  return (
    <footer className="contact-form" id="Contact" height="fit-content">
      <motion.img
        src={logo}
        alt="logo"
        className={`footer-logo-img`}
         initial={{ scale: 0 }}
         transition={{ duration: 1 }}
         whileInView={{ scale: 1 }}
         viewport={{ once: true }}
      />
      <Typography
        variant="overline"
        component={motion.p}
        initial={{ scale: 0 }}
        whileInView={{ scale: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        {profileData.quote}
      </Typography>
      <Box>
        {profileData["Contact"].map((item) => (
          <IconButton
            key={item.key}
            aria-label={item.key}
            onClick={() => {
              window.open(item.link, "_blank");
            }}
          >
            {item.icon}
          </IconButton>
        ))}
      </Box>
    </footer>
  );
};

export default ContactMe;
